<div class="row">
    <div class="col-md-8 organization-title">
        <h3>{{ 'SELECT_ORG_PAGE.TITLES.SELECT_ORGANIZATION' | transloco }}</h3>
    </div>
    <div class="col-md-4 text-end">
        <div class="search-wrapper">
            <mat-form-field class="mat-filed" [floatLabel]="'never'">
                <input
                    matInput
                    type="text"
                    placeholder="{{ 'SELECT_ORG_PAGE.LABELS.SEARCH' | transloco }}"
                    [(ngModel)]="searchText"
                    (keyup)="searchResult($event)"
                    autocomplete="off"
                />
                <button mat-button matPrefix mat-icon-button class="search_btn">
                    <mat-icon>search</mat-icon>
                </button>
            </mat-form-field>

            <button type="buttotn" [routerLink]="['/management/add-organization']" class="btn secondary-ebtn" *ngIf="hideAddOption === true">
                {{ 'SELECT_ORG_PAGE.LABELS.ADD_ORGANIZATION' | transloco }}
            </button>
        </div>
    </div>
    <a [routerLink]="['/management/add-organization']"></a>
</div>
<div class="org-section-scroll">
    <div class="row mt-4 mb-4" style="display: contents">
        <div class="organization_container" *ngIf="organization.length > 0">
            <div
                class="col-xl-4 col-lg-4 col-md-4 mt-4 mb-4 px-4 organization-wrapper"
                id="{{ org.organisationId }}"
                *ngFor="let org of organization; let i = index"
            >
                <div
                    class="position-relative"
                    [matTooltip]="'Access to this ' + org.organisationName + ' has expired. To request an extension, please contact your administrator.'"
                    [matTooltipDisabled]="!disableOrg(org)"
                    matTooltipPosition="above"
                >
                    <div class="org-image" (click)="!disableOrg(org) && selectOrg(org)" [style.cursor]="disableOrg(org) ? 'default' : 'pointer'">
                        <img *ngIf="org.logo" [src]="org.logo" alt="logo" />
                        <!-- <ngx-avatars
                            *ngIf="!org.logo"
                            name="{{ org.organisationName }}"
                            size="100"
                            initialsSize="3"
                            #avatarLogo
                            bgColor="#ffcc01"
                            fgColor="#010101"
                        ></ngx-avatars> -->
                        <div
                            *ngIf="!org.logo"
                            #avatarLogo
                            class="custom-avatar"
                            [ngStyle]="{
                                width: '100px',
                                height: '100px',
                                backgroundColor: '#ffcc01',
                                color: '#010101',
                                fontSize: '32px',
                            }"
                        >
                            {{ getInitials(org.organisationName) }}
                        </div>
                    </div>
                    <div class="organization_div" (click)="!disableOrg(org) && selectOrg(org)" [style.cursor]="disableOrg(org) ? 'default' : 'pointer'">
                        <div class="icon-wrapper"></div>
                        <div style="display: none">It is for getting the child element</div>
                        <br />
                        <h3>{{ org.organisationName }}</h3>

                        <hr />

                        <div class="metrics">
                            <div class="metric">
                                <span>PA Instance(s)</span>
                                <strong>{{ org.instanceCountiDMS }}</strong>
                            </div>
                            <div class="metric">
                                <span>IA Instance(s)</span>
                                <strong>{{ org.instanceCountICE }}</strong>
                            </div>
                            <div class="metric">
                                <span>User(s)</span>
                                <strong>{{ org.userCount }}</strong>
                            </div>
                        </div>
                        <i *ngIf="hideEditOption == true && !disableOrg(org)" class="fa fa-edit edit-icon" (click)="navigateAddOrg(org.organisationId)"></i>
                        <i *ngIf="hideEditOption == false && !disableOrg(org)" class="fas fa-eye edit-icon" (click)="navigateAddOrg(org.organisationId)"></i>
                        <i *ngIf="disableOrg(org)" class="fa fa-ban edit-icon disabled-org-icon" aria-hidden="true"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="organization_container" *ngIf="organization.length == 0 && !searchText">
            <p class="no-org-mesaage">{{ 'SELECT_ORG_PAGE.LABELS.NO_ORGANIZATION_AVAILABLE_TO_SELECT' | transloco }}</p>
        </div>

        <div *ngIf="organization.length == 0 && searchText">
            <p class="no-org-mesaage">{{ "SELECT_ORG_PAGE.LABELS.WE_COUNDN'T_FIND_ANY_ORGANIZATION_FOR" | transloco }} '{{ searchText }}'</p>
        </div>
    </div>
</div>
